import { Link, useNavigate } from 'react-router';
import { useUsers } from '@/lib/directory/use-users';
import { Button, DataTable, PriorityBadge, StateBadge, type Column } from '@/lib/ui';
import { formatDate } from '@/lib/utils/format';
import type { WorkOrder } from '@shared/types';
import { useCompanyWorkOrders } from './hooks';

export function CompanyWorkOrdersTab({ companyId }: { companyId: string }) {
  const navigate = useNavigate();
  const { data, loading } = useCompanyWorkOrders(companyId);
  const { byId } = useUsers();
  const columns: Column<WorkOrder>[] = [
    { key: 'id', header: 'Number', sortValue: (r) => r.id, render: (r) => <Link className="inc-number" to={`/crm/work-orders/${r.id}`}>{r.id}</Link> },
    { key: 'short', header: 'Short description', sortValue: (r) => r.short, render: (r) => r.short },
    { key: 'priority', header: 'Priority', render: (r) => <PriorityBadge priority={r.priority} /> },
    { key: 'state', header: 'State', render: (r) => <StateBadge state={r.state} /> },
    { key: 'tech', header: 'Technician', render: (r) => byId.get(r.assignedTechUid ?? '')?.name ?? '—' },
    { key: 'scheduled', header: 'Scheduled', sortValue: (r) => r.scheduledStart?.toMillis?.() ?? 0, render: (r) => (r.scheduledStart ? formatDate(r.scheduledStart, { withTime: true }) : '—') },
  ];
  return (
    <div className="card">
      <div className="card-header"><span className="card-title">Work orders</span><Button size="sm" variant="primary" onClick={() => navigate(`/crm/work-orders/new?company=${companyId}`)}>New work order</Button></div>
      <DataTable columns={columns} rows={data} rowKey={(r) => r.id} loading={loading} onRowClick={(r) => navigate(`/crm/work-orders/${r.id}`)} emptyMessage="No work orders for this company" />
    </div>
  );
}
